export enum SpecFieldClasses {
  PRODUCT_SELECTION = 'field-12x field-lg-7x field-xl-8x',
  QUANTITY = 'field-12x field-md-6x field-lg-3x field-xl-2x',
  UNIT = 'field-12x field-md-6x field-lg-2x field-xl-2x',
  DATE = 'field-12x field-md-6x field-lg-3x',
  TIME = 'field-12x field-md-6x field-lg-3x push-lg-6x',
  TIME_NO_PUSH = 'field-12x field-md-6x field-lg-3x',
  CONTRACT = 'field-12x field-md-6x',
  CONTRACT_ANTICIPATED_INVOICE = 'field-12x field-md-6x',
  PAYMENT_TERMS = 'field-12x field-md-6x field-lg-3x field-xl-2x push-lg-3x push-xl-4x',
  ADDITIONAL_INFO = 'field-12x additional-info--with-separator',
  PROJECT_PROFILES = 'field-12x field-md-6x push-lg-6x',
  UNLOAD_TYPE = 'field-12x field-md-6x field-lg-3x',
  PUMP = 'field-12x field-md-6x field-lg-3x',
  PIPE_QUANTITY = 'field-12x field-md-6x field-lg-3x',
  DISCHARGE_TIME = 'field-12x field-md-6x field-lg-3x field-xl-2x',
  APPLICATION = 'field-12x field-md-6x field-lg-3x',
  SPACING = 'field-12x field-md-6x field-lg-2x field-xl-2x',
  SLUMP = 'field-12x field-md-6x field-lg-3x field-xl-2x',
  CLEAN_UP = 'field-12x field-md-6x field-lg-2x field-xl-2x',
  ADDITIONAL_SERVICES = 'field-12x field-md-6x',
  ADDITIONAL_PRODUCTS = 'field-12x field-md-6x',
  DELIVERY_MODE = 'field-12x field-md-6x field-lg-3x field-xl-2x push-lg-3x push-xl-4x',
  PLANTS = 'field-12x field-md-6x field-lg-3x',
  VEHICLE = 'field-12x field-md-6x field-lg-3x',
  LOAD_SIZE = 'field-12x field-md-6x field-lg-3x field-xl-2x',

  CEMEXPUMP_REQUIRED_SIZE = 'field-12x field-md-6x field-lg-3x field-xl-3x',
  CEMEXPUMP_ALTERNATIVE_SIZE_TO_MAXIMUM = 'field-12x field-md-6x field-lg-3x field-xl-3x',
  CEMEXPUMP_PIPE_LENGTH = 'field-12x field-md-6x field-lg-2x field-xl-2x',
  CEMEXPUMP_PIPE_DIAMETER = 'field-12x field-md-6x field-lg-2x field-xl-2x push-lg-2x',
  CEMEXPUMP_PRIMER_BY_CEMEX = 'field-12x field-md-6x field-lg-3x field-xl-3x',
  CEMEXPUMP_POWER_LINE = 'field-12x field-md-6x field-lg-3x field-xl-3x items-on-row',
  CEMEXPUMP_FALL_PROTECTION = 'field-12x field-md-6x field-lg-3x field-xl-3x items-on-row',
  CEMEXPUMP_CLEANING_ON_SITE = 'field-12x field-md-6x field-lg-3x field-xl-3x items-on-row',
  CEMEXPUMP_COMMENTS = 'field-12x additional-info--with-separator',
  CEMEXPUMP_PIPES = 'field-12x field-md-6x field-lg-1x field-xl-1x',
  CEMEXPUMP_1M3GROUT = 'field-12x field-md-6x field-lg-1x field-xl-1x',
  CEMEXPUMP_DISTANCE_PUMP_SITE = 'field-12x field-md-6x field-lg-3x field-xl-2x',
  CEMEXPUMP_DEPARTURE_BOOM_PIPES = 'field-12x field-md-6x field-lg-3x field-xl-2x',
  CEMEXPUMP_PRIMER = 'field-12x field-md-6x field-lg-1x field-xl-1x',
  CEMEXPUMP_ADDITIONAL_SERVICES = 'field-12x field-md-6x',
  CEMEXPUMP_PUMPING_SERVICE_PRODUCT = 'field-12x field-md-6x',

  CEMEXPUMP_CLEANING_POSSIBLE = 'field-12x field-md-6x field-lg-1x field-xl-1x',
  CEMEXPUMP_REQUEST_VISIT = 'field-12x field-md-6x field-lg-1x field-xl-1x',
  CEMEXPUMP_SPECIFIC_PERMITS = 'field-12x field-md-6x field-lg-1x field-xl-1x',
  CEMEXPUMP_ENTRY_PASS_NEEDED = 'field-12x field-md-6x field-lg-1x field-xl-1x',
}
